/* eslint-disable prettier/prettier */
import pipe from "@insightfulscience/shared-utils/lib/fn/pipe";
import * as t from "./transduce";
import { isString, isNotEmpty, isUnique } from "./predicates";

const trim = value => value.trim();

export const cn = className => (isString(className) ? trim(className) : "");

const join = (separator = "") => (text, str) =>
	(text && str && `${text}${separator}${str}`) || str || text;

export const classes = (...classNames) =>
	classNames.reduce(
		pipe(
			join(" "),
			t.filter(isUnique()),
			t.filter(isNotEmpty),
			t.map(trim),
			t.filter(isString),
		),
		""
	);
